import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TextService } from '../../services/text.service';
import { SessionService } from '../../services/session.service';
import { SdkInitText } from '../../../model/user/sdk-init-text';
import { NetmeraService } from "../../../shared/services/netmera-service";
import { SifremiUnuttum } from "../../../model/netmera-events/sifremi-unuttum";
import { Error } from "../../../model/netmera-events/error";

@Component({
  selector: 'pa-forgot-password-notification',
  templateUrl: './forgot-password-notification.component.html',
  styleUrls: ['./forgot-password-notification.component.scss']
})
export class ForgotPasswordNotificationComponent implements OnInit {

  email: string;
  emailVerification: boolean;
  hasVerificationEmail: boolean;
  hasSendEmail: boolean;
  textService: TextService;
  trackingId: string;
  merchantCode: string;
  sdkInitTexts: Array<SdkInitText>;

  constructor(private router: Router, private route: ActivatedRoute, private userService: UserService, private sessionService: SessionService,
              textService: TextService, private netmeraService: NetmeraService, private sifremiUnuttum: SifremiUnuttum, private error: Error) {
    this.textService = textService;
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.trackingId = params['trackingId'];
      this.isThereMailVerification();
    });
  }

  isThereMailVerification() {
    this.userService.isThereMailVerification(this.trackingId).subscribe(response => {
      if (response == false) {
        this.emailVerification = true;
        this.getMaskedEmail();
      } else {
        this.emailVerification = false;
        this.getMaskedEmail();
      }
      this.sessionService.getInitUser(this.trackingId).subscribe(response => {
        this.sdkInitTexts = response.sdkInitTexts;
        this.merchantCode = response?.requestHeader?.merchant?.merchantCode;
        this.netmeraService.pushEvent(this.sifremiUnuttum.setEventObject("SifremiUnuttumSayfasi", this.merchantCode));
      },error => {
        this.router.navigate(['/result/error', this.trackingId]);
      });
    }, error => {
      this.router.navigate(['/result/error', this.trackingId]);
    });
  }

  getMaskedEmail() {
    this.userService.getMaskedEmail(this.trackingId).subscribe(
      response => {
        this.email = response.maskedEmail;
      },
      error => {
        this.router.navigate(['/result/error', this.trackingId]);
      });
  }

  sendRecoveryEmail(): void {

    this.userService.sendRecoveryEmail(this.trackingId).subscribe(
      response => {
        this.hasSendEmail = true;
        this.netmeraService.pushEvent(this.sifremiUnuttum.setEventObject("EpostaGondermeBasarili", this.merchantCode));
      },
      error => {
        this.netmeraService.pushEvent(this.sifremiUnuttum.setEventObject("EpostaGondermeBasarisiz", this.merchantCode));
        this.netmeraService.pushEvent(this.error.setEventObject("EpostaGondermeBasarisiz", this.merchantCode));
        this.router.navigate(['/result/error', this.trackingId]);
      }
    );
  }

  sendVerificationEmail() {
    this.userService.sendEmailValidation(this.trackingId).subscribe((res: Response) => {
      this.hasVerificationEmail = true;
      this.netmeraService.pushEvent(this.sifremiUnuttum.setEventObject("EpostaGondermeBasarili", this.merchantCode));
    }, error => {
      this.netmeraService.pushEvent(this.sifremiUnuttum.setEventObject("EpostaGondermeBasarisiz", this.merchantCode));
      this.netmeraService.pushEvent(this.error.setEventObject("EpostaGondermeBasarisiz", this.merchantCode));
      this.router.navigate(['/result/error', this.trackingId]);
    });
  }

}
